import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryName
} from '../../categories/categoriesTypes';

export interface FetchCacheProductBrandsSelectedQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  name: CategoryName;
}

export const FETCH_CACHE_PRODUCT_BRANDS_SELECTED_QUERY = gql`
  query CacheProductBrandsSelectedCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    categories(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        name
        uuid
      }
      sql
    }
  }
`;
